export default {
  name: 'TimelineTaskItem',
  props: ['task', 'name'],
  methods: {
    onClick() {
      $(this.$refs.content).collapse('toggle');
    }
  },
  computed: {
    createItemID() {
      return `${this.name}__${this.task.id}`;
    },
    status: {
      get() {
        return this.task.status.toLowerCase() === 'completed';
      },
      set(value) {
        if (value) {
          this.task.status = 'Completed';
        } else {
          this.task.status = 'Open';
        }
        this.$store.dispatch('tasks/taskStatus', {
          taskID: this.task.id,
          status: this.task.status
        });
      }
    }
  }
};